/**
 * Título de seção, com ação opcional à direita ("See all").
 *
 * Referência: "Meal Category — See All" (Dribbble 15125197) e "Related —
 * View all" (27589455). Era uma etiqueta em caixa alta de 15px com
 * espaçamento de letra: a marca visual de tela de ajustes. Virou um título
 * de verdade, em caixa normal, --t-item, na serifa dos títulos do app.
 */
export function Secao({
  children,
  acao,
}: {
  children: string;
  acao?: { rotulo: string; onClick: () => void };
}) {
  return (
    <div
      className="flex items-end justify-between gap-4"
      style={{ padding: "var(--entre-secoes) var(--gutter) 14px" }}
    >
      {/* .secao-titulo: a primeira letra sempre maiúscula — várias etiquetas
          vêm de chaves que também servem no meio de frase ("servings"). */}
      <h2 className="secao-titulo min-w-0 font-bold leading-tight" style={{ fontSize: "var(--t-item)", color: "var(--tinta)" }}>
        {children}
      </h2>
      {acao && (
        <button
          type="button"
          onClick={acao.onClick}
          className="shrink-0 font-semibold leading-none"
          style={{ fontSize: "var(--t-apoio)", color: "hsl(var(--accent))", minHeight: 44, padding: "0 4px" }}
        >
          {acao.rotulo}
        </button>
      )}
    </div>
  );
}
